import { NavigateRoutes } from 'common/constants/app.constant';
import { BaseDataModel, FormMetaModel, HeaderList } from '../../utilitymodels/base.model';

export class OtherOpportuinityItem {
    name: string;
    img: string;
    url: string;
    investorList: any = [];
    schemeList: [] = [];
    text: string;
    remText?: string;
    pageTitle: string;
    toolTipData: string;
    headerList: HeaderList[] = [];
    rowList: string[] = [];
    actionList: ActionTask;
    showSubTable: boolean = false;
    deepLink: boolean = false;
}

export class ActionTask {
    name: string;
    logo: string;
    list: subList[] = [];
    redirctionPage?: string = '';
}

export class subList {
    name: string;
    logo: string;
    type: string;
}

export const otherUrl = {
    redeem: NavigateRoutes.otherOpportunityList + '/redeem',
    nigo: NavigateRoutes.otherOpportunityList + '/nigo',
    expiredstp: NavigateRoutes.otherOpportunityList + '/expiredstp',
    expiredswp: NavigateRoutes.otherOpportunityList + '/expiredswp',
    elss: NavigateRoutes.otherOpportunityList + '/elss',
};
export class OtherOpportunityModel extends BaseDataModel {
    listInfo: OtherOpportuinityItem[] = [
        {
            name: 'Redeemed',
            img: 'assets/icon/card/recent-redemption.svg',
            investorList: [],
            schemeList: [],
            url: otherUrl.redeem,
            text: 'Recently',
            pageTitle: 'Recently Redeemed',
            toolTipData: 'This report helps you with a list of all the investors who have redeemed their investment in the last two months.',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Scheme Name',
                    logo: 'assets/icon/reports/sip-report/document-text.svg',
                },
                {
                    name: 'Redemption Date',
                    logo: 'assets/icon/reports/sip-report/calendar-2.svg',
                },
                {
                    name: 'Exit load Amount',
                    logo: 'assets/icon/transaction/coin.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: ['SCHEME_NAME', 'TRXN_DATE', 'EXIT_LOAD'],
            actionList: {
                name: 'TRANSACT',
                logo: '',
                list: [
                    {
                        name: 'Buy More',
                        logo: 'assets/icon/actionsheet/buyMore.svg',
                        type: 'lumpsum',
                    },
                    {
                        name: 'Start SIP',
                        logo: 'assets/icon/actionsheet/SIP.svg',
                        type: 'sip',
                    },
                ],
            },
            showSubTable: true,
            deepLink: false,
        },
        // {
        //     name: 'Not In Good Order',
        //     img: 'assets/icon/card/nigo-investment.svg',
        //     investorList: [],
        //     schemeList: [],
        //     url: otherUrl.nigo,
        //     text: 'Rejected due to',
        //     pageTitle: 'NIGO Opportunity',
        //     toolTipData: ' This report helps you with the list of all the investors whose transactions were rejected due to the reason Not In Good Order (NIGO)',
        //     headerList: [
        //         {
        //             name: 'Investor Details',
        //             logo: 'assets/icon/reports/sip-report/user.svg',
        //         },
        //         {
        //             name: 'Scheme Name',
        //             logo: 'assets/icon/reports/sip-report/document-text.svg',
        //         },
        //         {
        //             name: 'Rejection Date',
        //             logo: 'assets/icon/reports/sip-report/calendar-2.svg',
        //         },
        //         {
        //             name: 'Amount',
        //             logo: 'assets/icon/transaction/coin.svg',
        //         },
        //         {
        //             name: 'Type',
        //             logo: 'assets/icon/reports/sip-report/coin.svg',
        //         },
        //         {
        //             name: 'Actions',
        //             logo: '',
        //         },
        //     ],
        //     rowList: ['SCHEME_NAME', 'DATE_OF_REJECTION', 'AMOUNT', 'transType'],
        //     actionList: {
        //         name: 'Contact Us',
        //         logo: 'assets/icon/card/call-primary-outline.svg',
        //         list: [],
        //         redirctionPage: 'initiat-transaction',
        //     },
        //     showSubTable: false,
        //     deepLink: false,
        // },
        {
            name: 'STP Expiry',
            img: 'assets/icon/card/stp-expired.svg',
            investorList: [],
            schemeList: [],
            url: otherUrl.expiredstp,
            text: 'Upcoming',
            pageTitle: 'Upcoming STP Expiry',
            toolTipData: 'This report helps you with the list of STP transactions of your investors that will expire in the coming two months',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Scheme Name',
                    logo: 'assets/icon/reports/sip-report/document-text.svg',
                },
                {
                    name: 'Start Date',
                    logo: 'assets/icon/reports/sip-report/calendar-2.svg',
                },
                {
                    name: 'End Date',
                    logo: 'assets/icon/reports/sip-report/calendar-tick.svg',
                },
                {
                    name: 'STP Amount',
                    logo: 'assets/icon/transaction/coin.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: ['FROM_DATE', 'TO_DATE', 'AMOUNT'],
            actionList: {
                name: 'Restart STP',
                logo: 'assets/icon/card/card-up.svg',
                list: [],
                redirctionPage: 'stp',
            },
            showSubTable: true,
            deepLink: false,
        },
        {
            name: 'SWP Expiry',
            img: 'assets/icon/card/expired-swp.svg',
            investorList: [],
            schemeList: [],
            url: otherUrl.expiredswp,
            text: 'Upcoming',
            pageTitle: 'Upcoming SWP Expiry',
            toolTipData: 'This report helps you with the list of SWP transactions of your investors that will expire in the coming two months.',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Scheme Name',
                    logo: 'assets/icon/reports/sip-report/document-text.svg',
                },
                {
                    name: 'Start Date',
                    logo: 'assets/icon/reports/sip-report/calendar-2.svg',
                },
                {
                    name: 'End Date',
                    logo: 'assets/icon/reports/sip-report/calendar-tick.svg',
                },
                {
                    name: 'Frequency',
                    logo: 'assets/icon/reports/sip-report/timer.svg',
                },
                {
                    name: 'SWP Amount',
                    logo: 'assets/icon/transaction/coin.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: ['SOURCE_SCHEME', 'FROM_DATE', 'TO_DATE', 'FREQUENCY', 'AMOUNT'],
            actionList: {
                name: 'Restart SWP',
                logo: 'assets/icon/card/wallet-add.svg',
                list: [],
                redirctionPage: 'swp',
            },
            showSubTable: false,
            deepLink: false,
        },
        {
            name: 'Zero ELSS Investment in CFY',
            img: 'assets/icon/card/elss-investment.svg',
            investorList: [],
            schemeList: [],
            url: otherUrl.elss,
            text: '',
            pageTitle: 'ELSS Opportunity',
            toolTipData: 'This report helps you with the list of all the investors who have invested less than Rs. 1,50,000 in the ELSS Fund in the CFY',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Total ELSS investment Opportunity',
                    logo: 'assets/icon/reports/sip-report/calendar-tick.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: ['Elss_Investment'],
            actionList: {
                name: 'TRANSACT',
                logo: '',
                list: [
                    {
                        name: 'Buy More',
                        logo: 'assets/icon/actionsheet/buyMore.svg',
                        type: 'lumpsum',
                    },
                    {
                        name: 'Start SIP',
                        logo: 'assets/icon/actionsheet/SIP.svg',
                        type: 'sip',
                    },
                ],
            },
            showSubTable: false,
            deepLink: false,
        },
    ];
    errorModel: any[] = [];
}

export class OtherOpportunityMetaModel extends FormMetaModel {
    constructor() {
        super('Other Opportunities', '', false, NavigateRoutes.oppotunity);
    }

    initProperties() {
        return {};
    }
}
